<template>
  <div>
    <p class="caption mb-4" style="color: rgba(0,0,0,0.55)">Defina o tipo de cálculo, as metas e o valor do bônus por serviço.</p>

    <div class="d-flex mb-3" style="gap: 10px; align-items: stretch">
      <div style="flex: 1 1 0; border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: rgba(0,0,0,0.015)">
        <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Tipo de Meta</p>
        <div class="d-flex" style="gap: 6px">
          <button
            v-for="opt in tiposMeta"
            :key="opt.value"
            type="button"
            @click="setTipoMeta(opt.value)"
            class="rounded pa-2 text-center caption font-weight-medium flex-grow-1"
            style="cursor: pointer; border: 2px solid; transition: all 0.2s; font-family: inherit; outline: none; -webkit-appearance: none; appearance: none"
            :style="form.tipoMeta === opt.value ? 'border-color: #1976d2; background: rgba(25,118,210,0.06); color: #1976d2' : 'border-color: rgba(0,0,0,0.12); background: white; color: rgba(0,0,0,0.6)'"
          >{{ opt.label }}</button>
        </div>
      </div>
      <div style="flex: 1 1 0; border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: rgba(0,0,0,0.015)">
        <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Tipo de Cálculo</p>
        <div class="d-flex" style="gap: 6px">
          <button
            v-for="opt in tiposCalculo"
            :key="opt.value"
            type="button"
            @click="setTipoCalculo(opt.value)"
            class="rounded pa-2 text-center caption font-weight-medium flex-grow-1"
            style="cursor: pointer; border: 2px solid; transition: all 0.2s; font-family: inherit; outline: none; -webkit-appearance: none; appearance: none"
            :style="form.tipoCalculo === opt.value ? 'border-color: #1976d2; background: rgba(25,118,210,0.06); color: #1976d2' : 'border-color: rgba(0,0,0,0.12); background: white; color: rgba(0,0,0,0.6)'"
          >{{ opt.label }}</button>
        </div>
      </div>
      <div style="flex: 1 1 0; border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: rgba(0,0,0,0.015)">
        <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Tipo de Pagamento</p>
        <div class="d-flex" style="gap: 6px">
          <button
            v-for="opt in tiposPagamento"
            :key="opt.value"
            type="button"
            @click="setTipoPagamento(opt.value)"
            class="rounded pa-2 text-center caption font-weight-medium flex-grow-1"
            style="cursor: pointer; border: 2px solid; transition: all 0.2s; font-family: inherit; outline: none; -webkit-appearance: none; appearance: none"
            :style="form.tipoPagamento === opt.value ? 'border-color: #1976d2; background: rgba(25,118,210,0.06); color: #1976d2' : 'border-color: rgba(0,0,0,0.12); background: white; color: rgba(0,0,0,0.6)'"
          >{{ opt.label }}</button>
        </div>
      </div>
    </div>

    <v-alert v-if="form.tipoCalculo" type="info" dense text class="caption mb-3">
      <div class="mb-1"><strong>Meta:</strong> {{ descricaoTipoMeta }}</div>
      <div v-if="descricaoTipoCalculo" class="mb-1"><strong>Cálculo:</strong> {{ descricaoTipoCalculo }}</div>
      <div><strong>Pagamento:</strong> {{ descricaoTipoPagamento }}</div>
    </v-alert>

    <!-- Modo Coletivo -->
    <template v-if="form.tipoMeta !== 'individual'">
      <div v-if="form.modelosSelecionados.length > 0" class="mb-4" style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: rgba(0,0,0,0.015)">
        <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Metas por Serviço</p>
        <div v-for="m in form.modelosSelecionados" :key="m.id_servico" class="pa-3 rounded mb-2" style="background: white; border: 1px solid rgba(0,0,0,0.12)">
          <p class="caption font-weight-medium mb-2" style="color: rgba(0,0,0,0.7)">{{ m.id_servico }} — {{ m.servico }}</p>
          <template v-if="form.tipoCalculo === 2">
            <div class="d-flex justify-space-between align-center mb-2">
              <span class="caption grey--text text--darken-1">Faixas de Quantidade</span>
              <v-btn x-small outlined color="primary" @click="adicionarFaixaItem(m.id_servico)">
                <v-icon x-small class="mr-1">mdi-plus</v-icon>Adicionar Faixa
              </v-btn>
            </div>
            <div v-for="(faixa, idx) in getFaixasItem(m.id_servico)" :key="idx" class="mb-2 pa-3 rounded" style="background: rgba(0,0,0,0.02); border: 1px solid rgba(0,0,0,0.08)">
              <div class="d-flex align-end" style="gap: 8px">
                <v-text-field :value="faixa.minimo" @input="atualizarFaixaItem(m.id_servico, idx, 'minimo', $event)" label="Mínimo" type="number" dense outlined style="flex: 1" :hide-details="!getFaixaOrdemErroItem(m.id_servico, idx)" :error-messages="getFaixaOrdemErroItem(m.id_servico, idx)"></v-text-field>
                <v-text-field :value="faixa.maximo" @input="atualizarFaixaItem(m.id_servico, idx, 'maximo', $event)" label="Máximo" type="number" dense outlined hide-details style="flex: 1"></v-text-field>
                <v-text-field :value="faixa.bonus" @input="atualizarFaixaItem(m.id_servico, idx, 'bonus', $event)" :label="form.tipoPagamento === 1 ? 'R$ / unidade' : 'Bônus fixo (R$)'" type="number" dense outlined hide-details style="flex: 1"></v-text-field>
                <v-btn v-if="getFaixasItem(m.id_servico).length > 2" icon x-small color="error" @click="removerFaixaItem(m.id_servico, idx)" class="mb-1 flex-shrink-0"><v-icon small>mdi-close</v-icon></v-btn>
              </div>
            </div>
            <v-alert v-if="getFaixasItem(m.id_servico).length < 2" type="warning" dense text class="mt-2 caption mb-0">Adicione pelo menos 2 faixas para continuar.</v-alert>
          </template>
          <template v-else>
            <div class="d-flex" style="gap: 8px">
              <v-text-field :value="getMetaItemValor(m.id_servico, 'metaValor')" @input="setMetaItemValor(m.id_servico, 'metaValor', $event)" label="Qtde Meta" type="number" dense outlined placeholder="0" hide-details style="flex: 1"></v-text-field>
              <v-text-field :value="getMetaItemValor(m.id_servico, 'valorBonus')" @input="setMetaItemValor(m.id_servico, 'valorBonus', $event)" :label="form.tipoPagamento === 1 ? 'Bônus / unidade (R$)' : 'Bônus fixo (R$)'" prefix="R$" type="number" dense outlined placeholder="0,00" hide-details style="flex: 1"></v-text-field>
            </div>
          </template>
        </div>
      </div>
    </template>

    <!-- Modo Individual -->
    <template v-else-if="form.modelosSelecionados.length > 0 && form.colaboradoresSelecionados.length > 0">

      <!-- Individual — Meta Fixa -->
      <template v-if="form.tipoCalculo !== 2">
        <div
          v-for="colab in form.colaboradoresSelecionados"
          :key="colab.id_colaborador"
          class="mb-3"
          style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 12px 14px; background: rgba(0,0,0,0.015)"
        >
          <p class="body-2 font-weight-medium ma-0 mb-1" style="color: rgba(0,0,0,0.75)">{{ colab.colaborador }}</p>
          <p class="caption grey--text ma-0 mb-3">{{ colab._funcao }}</p>
          <div v-for="m in form.modelosSelecionados" :key="m.id_servico" class="mb-2 pa-3 rounded" style="background: white; border: 1px solid rgba(0,0,0,0.12)">
            <p class="caption font-weight-medium ma-0 mb-2" style="color: rgba(0,0,0,0.7)">{{ m.id_servico }} — {{ m.servico }}</p>
            <div class="d-flex" style="gap: 8px">
              <v-text-field
                :value="getIndividualItemValor(colab.id_colaborador, m.id_servico, 'metaValor')"
                @input="setIndividualItemValor(colab.id_colaborador, m.id_servico, 'metaValor', $event)"
                label="Qtde Meta" type="number" dense outlined placeholder="0" hide-details style="flex: 1"
              ></v-text-field>
              <v-text-field
                :value="getIndividualItemValor(colab.id_colaborador, m.id_servico, 'valorBonus')"
                @input="setIndividualItemValor(colab.id_colaborador, m.id_servico, 'valorBonus', $event)"
                :label="form.tipoPagamento === 1 ? 'Bônus / unidade (R$)' : 'Bônus fixo (R$)'" prefix="R$" type="number" dense outlined placeholder="0,00" hide-details style="flex: 1"
              ></v-text-field>
            </div>
          </div>
        </div>
      </template>

      <!-- Individual — Faixa Progressiva -->
      <div v-else style="display: flex; flex-direction: column; gap: 12px">
        <div
          v-for="colab in form.colaboradoresSelecionados"
          :key="colab.id_colaborador"
          style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 12px 14px; background: rgba(0,0,0,0.015)"
        >
          <p class="body-2 font-weight-medium ma-0 mb-1" style="color: rgba(0,0,0,0.75)">{{ colab.colaborador }}</p>
          <p class="caption grey--text ma-0 mb-3">{{ colab._funcao }}</p>
          <div v-for="m in form.modelosSelecionados" :key="m.id_servico" class="mb-3">
            <div class="d-flex justify-space-between align-center mb-2">
              <span class="caption font-weight-medium" style="color: rgba(0,0,0,0.7)">{{ m.id_servico }} — {{ m.servico }}</span>
              <v-btn x-small outlined color="primary" @click="adicionarFaixaIndividualItem(colab.id_colaborador, m.id_servico)">
                <v-icon x-small class="mr-1">mdi-plus</v-icon>Adicionar Faixa
              </v-btn>
            </div>
            <div v-for="(faixa, idx) in getIndividualItemFaixas(colab.id_colaborador, m.id_servico)" :key="idx" class="mb-2 pa-3 rounded" style="background: white; border: 1px solid rgba(0,0,0,0.1)">
              <div class="d-flex align-end" style="gap: 8px">
                <v-text-field :value="faixa.minimo" @input="atualizarFaixaIndividualItem(colab.id_colaborador, m.id_servico, idx, 'minimo', $event)" label="Mínimo" type="number" dense outlined style="flex: 1" :hide-details="!getFaixaOrdemErroIndividualItem(colab.id_colaborador, m.id_servico, idx)" :error-messages="getFaixaOrdemErroIndividualItem(colab.id_colaborador, m.id_servico, idx)"></v-text-field>
                <v-text-field :value="faixa.maximo" @input="atualizarFaixaIndividualItem(colab.id_colaborador, m.id_servico, idx, 'maximo', $event)" label="Máximo" type="number" dense outlined style="flex: 1" :hide-details="!getFaixaMaximoErroIndividualItem(colab.id_colaborador, m.id_servico, idx)" :error-messages="getFaixaMaximoErroIndividualItem(colab.id_colaborador, m.id_servico, idx)"></v-text-field>
                <v-text-field :value="faixa.bonus" @input="atualizarFaixaIndividualItem(colab.id_colaborador, m.id_servico, idx, 'bonus', $event)" :label="form.tipoPagamento === 1 ? 'R$ / unidade' : 'Bônus fixo (R$)'" type="number" dense outlined hide-details style="flex: 1"></v-text-field>
                <v-btn v-if="getIndividualItemFaixas(colab.id_colaborador, m.id_servico).length > 2" icon x-small color="error" @click="removerFaixaIndividualItem(colab.id_colaborador, m.id_servico, idx)" class="mb-1 flex-shrink-0"><v-icon small>mdi-close</v-icon></v-btn>
              </div>
            </div>
            <v-alert v-if="getIndividualItemFaixas(colab.id_colaborador, m.id_servico).length < 2" type="warning" dense text class="mt-1 caption mb-0">Adicione pelo menos 2 faixas para continuar.</v-alert>
          </div>
        </div>
      </div>

    </template>
    <div v-else-if="form.tipoMeta === 'individual'" class="mb-4">
      <v-alert type="info" dense text class="caption">Selecione colaboradores e serviços nas etapas anteriores para definir metas individuais.</v-alert>
    </div>

    <CustoEstimadoCard
      :custo-estimado="custoEstimado"
      :n-colaboradores="form.colaboradoresSelecionados.length"
      :descricao-preenchido="descricaoPreenchido"
      descricao-vazio="Preencha as metas e bônus dos itens acima para visualizar a simulação de custo."
    />
  </div>
</template>

<script>
import calculoMixin from "./calculoMixin";
import CustoEstimadoCard from "./CustoEstimadoCard";
import { calcPorColaboradorItens, gerarLinhasItens } from "./custoEstimadoUtils";

export default {
  name: "SubEtapaCalculoServico",

  mixins: [calculoMixin],

  components: { CustoEstimadoCard },

  props: {
    form: { type: Object, required: true }
  },

  data() {
    return { metasTick: 0 };
  },

  watch: {
    "form.metasModelos": { deep: true, handler() { this.metasTick++; } },
    "form.metasIndividuaisItens": { deep: true, handler() { this.metasTick++; } }
  },

  computed: {
    descricaoPreenchido() {
      if (this.form.tipoCalculo === 2) return "Simulação com atingimento da última faixa de todos os itens";
      return "Simulação com 100% de atingimento para todos";
    },

    custoEstimado() {
      void this.metasTick;
      const form = this.form;
      if (form.tipoMeta === "individual") {
        let total = 0;
        const linhas = [];
        form.colaboradoresSelecionados.forEach(c => {
          const colItens = (form.metasIndividuaisItens || {})[c.id_colaborador] || {};
          let colTotal = 0;
          if (form.tipoCalculo !== 2) {
            form.modelosSelecionados.forEach(m => {
              const item = colItens[m.id_servico] || {};
              const meta = parseFloat(item.metaValor) || 0;
              const bonus = parseFloat(item.valorBonus) || 0;
              colTotal += form.tipoPagamento === 1 ? meta * bonus : bonus;
            });
          } else {
            form.modelosSelecionados.forEach(m => {
              const faixas = (colItens[m.id_servico] || {}).faixas || [];
              if (faixas.length > 0) {
                const last = faixas[faixas.length - 1];
                const qtde = parseFloat(last.maximo) || parseFloat(last.minimo) || 0;
                const bonus = parseFloat(last.bonus) || 0;
                colTotal += form.tipoPagamento === 1 ? qtde * bonus : bonus;
              }
            });
          }
          total += colTotal;
          linhas.push({ label: c.colaborador || String(c.id_colaborador), valor: colTotal });
        });
        return { porColaborador: null, total, nSemanas: 1, linhas };
      }
      const getKey = m => m.id_servico;
      const getNome = m => `${m.id_servico} — ${m.servico}`;
      const porColaborador = calcPorColaboradorItens(
        form.modelosSelecionados, form.metasModelos, getKey, form.tipoCalculo, form.tipoPagamento
      );
      const linhas = gerarLinhasItens(
        form.modelosSelecionados, form.metasModelos, getKey, getNome, form.tipoCalculo, form.tipoPagamento
      );
      return { porColaborador, total: porColaborador * (form.colaboradoresSelecionados.length || 1), nSemanas: 1, linhas };
    }
  }
};
</script>
